import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3.25 5.5a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5H4V6.25a.75.75 0 0 0-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10 7.75a6 6 0 0 1 6 6 .75.75 0 0 0 1.5 0 7.5 7.5 0 0 0-7.5-7.5 7.5 7.5 0 0 0-5 1.917h-.002l-2.25 2.026a.75.75 0 0 0 1.004 1.114L6 9.284a6 6 0 0 1 4-1.533Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUndo;
